export default __webpack_public_path__ + "static/media/logo.196cdb4b.png";